import { CenterCoverImg, OptimizedImg, PCFooter } from '@commonPackage/components';
import { ContactType } from '@commonPackage/constants';
import { CaseList, DistributorSystems, PartnersList, SupportsList } from '@portalCommon/agent/config';
import { SectionTitle } from '@portalCommon/agent/SectionTitle';
import Steps from '@portalCommon/agent/Steps/index';
import { MetaConfig } from '@portalCommon/components';
import { IconCircle, IconHi } from '@portalCommon/components/Icon/index';
import { RouterConfigEnum } from '@portalCommon/constants';
import { useEnhancedNavigation } from '@portalCommon/hooks';
import { StyledButton } from '@portalCommon/styles/utils';
import { toContactPage } from '@portalCommon/utils';

import classnames from 'classnames/bind';
import { Back2Top, BillboardScroll, Contact, ContactBox, NavHeader, Consult } from '@/components';

import styles from './index.module.less';

const cx = classnames.bind(styles);

const Banner = () => {
  const enhancedNavigate = useEnhancedNavigation();
  return (
    <section className={cx('banner')}>
      <div className={cx('banner-content')}>
        <h1>合作伙伴计划</h1>
        <h1 className={cx('main')}>加入我们共享元宇宙红利</h1>
        <StyledButton
          styleType="gradient"
          onClick={() =>
            toContactPage({
              contactType: ContactType.agent,
              isMain: import.meta.env.VITE_MAIN === 'true',
              enhancedNavigate,
            })
          }
          className={cx('join-btn')}>
          申请加入
        </StyledButton>
      </div>
      <CenterCoverImg
        alt="合作伙伴计划"
        src="https://static.fuxi.netease.com/yaotai/portal/20220830/l7fnjq51_466517.png"
      />
    </section>
  );
};

const Supports = () => {
  return (
    <section className={cx('supports')}>
      <div className={cx('supports-content')}>
        <SectionTitle sub="可提供网易瑶台产品的培训认证、销售支持、技术支持、营销支持等服务">
          为合作伙伴提供<b>全方位支持</b>
        </SectionTitle>
        <div className={cx('supports-list')}>
          {SupportsList.map(item => (
            <section key={item.title} className={cx('supports-item')}>
              <OptimizedImg width={128} loading="lazy" src={item.icon} alt={item.title} />
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </section>
          ))}
        </div>

        <p className={cx('alert')}>
          <IconHi style={{ marginRight: '24px' }} />
          欢迎专业的 PCO、DMC、MICE 机构加入，共筑元宇宙数字活动
        </p>
      </div>
    </section>
  );
};

const DistributorSystem = () => {
  return (
    <section className={cx('system')}>
      <div className={cx('system-content')}>
        <SectionTitle>
          <b>授权代理商</b>体系
        </SectionTitle>
        <div className={cx('system-list')}>
          {DistributorSystems.map((item, index) => (
            <section key={item.title} className={cx('system-item')}>
              <h3>{item.title}</h3>
              {item.desc.map((desc, index) => (
                <p key={index}>{desc}</p>
              ))}
            </section>
          ))}
        </div>
      </div>
    </section>
  );
};

const ProcessFlow = () => {
  const enhancedNavigate = useEnhancedNavigation();
  return (
    <section className={cx('process-flow')}>
      <div className={cx('process-flow-content')}>
        <SectionTitle>
          加入<b>流程</b>
        </SectionTitle>
        <div className={cx('step-dots')}>
          {Steps.map(item => (
            <section key={item.title} className={cx('dot')}>
              <IconCircle key={item.title} />
            </section>
          ))}
        </div>
        <div className={cx('steps')}>
          {Steps.map(item => (
            <section key={item.title} className={cx('step-item')}>
              {item.icon}
              <h3>{item.title}</h3>
            </section>
          ))}
        </div>
        <div className={cx('btn-wrapper')}>
          <StyledButton
            className={cx('join-btn')}
            onClick={() =>
              toContactPage({
                contactType: ContactType.agent,
                isMain: import.meta.env.VITE_MAIN === 'true',
              })
            }
            styleType="gradient">
            申请加入
          </StyledButton>
        </div>
      </div>
    </section>
  );
};

const Partners = () => {
  return (
    <section className={cx('partners')}>
      <SectionTitle>
        优秀<b>合作伙伴</b>
      </SectionTitle>
      <div className={cx('partners-list')}>
        {PartnersList.map((item, index) => (
          <section className={cx('partners-pool')} key={index}>
            {item.map(item => (
              <OptimizedImg
                loading="lazy"
                src={item.icon}
                alt={item.title}
                key={item.title}
                className={cx('item')}></OptimizedImg>
            ))}
          </section>
        ))}
      </div>
    </section>
  );
};

const Case = () => {
  return (
    <section className={cx('case')}>
      <SectionTitle>
        伙伴<b>成功案例</b>
      </SectionTitle>
      <div style={{ marginTop: '102px', overflow: 'hidden' }}>
        <BillboardScroll identifyFlag="distributor-case" height={500} speed={30} width={2540}>
          {CaseList.map(item => {
            return (
              <section className={cx('case-item')} key={item.title}>
                <OptimizedImg height={259} className={cx('poster')} title={item.title} src={item.poster} />
                <div className={cx('case-content')}>
                  <h3>{item.title}</h3>
                  <p className={cx('desc')}>{item.desc}</p>
                </div>
              </section>
            );
          })}
        </BillboardScroll>
      </div>
    </section>
  );
};

const AuthorizedDistributor = () => {
  return (
    <>
      <MetaConfig routerPath={RouterConfigEnum.AgentPage} />
      <NavHeader isFixed isInitTransparent />
      <div>
        <Banner />
        <Supports />
        <DistributorSystem />
        <ProcessFlow />
        <Partners />
        <Case />
        <Consult routerPath={RouterConfigEnum.AgentPage} />
        <Contact />
        <PCFooter isMain={import.meta.env.VITE_MAIN === 'true'} />
        <ContactBox />
        <Back2Top />
      </div>
    </>
  );
};

export default AuthorizedDistributor;
